exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".layout--absolute--8t5yq{pointer-events:none;position:absolute}.layout--smallHorizontalPadding--aaAoX{padding:0 6px}", ""]);

// exports
exports.locals = {
	"absolute": "layout--absolute--8t5yq",
	"smallHorizontalPadding": "layout--smallHorizontalPadding--aaAoX"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/styles/layout.css
 ** module id = 16
 ** module chunks = 0
 **/